interface IProps {
  width?: number;
  height?: number;
}

export default function Location21({ width, height }: IProps) {
  return (
    <img
      className="timeline-layout--svg--icon"
      src="https://media.synctrack.io/megamind-estimated/icon-timeline/location21.gif"
      width={width || 30}
      height={height || 30}
      alt="location icon"
    />
  );
}
